export function modeSwitcher() {

  const getStoredTheme = () => localStorage.getItem('theme');
  const setStoredTheme = theme => localStorage.setItem('theme', theme);
  const isStoredTheme = theme => theme === 'light' || theme === 'dark';

  const getTimeBasedTheme = () => {
    const hour = new Date().getHours();
    return hour >= 8 && hour < 17 ? 'light' : 'dark';
  };

  const getPreferredTheme = () => {
    const storedTheme = getStoredTheme();
    if (isStoredTheme(storedTheme)) {
      return storedTheme;
    }

    return getTimeBasedTheme();
  };

  const setTheme = theme => {
    document.documentElement.setAttribute('data-bs-theme', theme);
  };

  setTheme(getPreferredTheme());

  const animateButton = (element, theme) => {
    const toggler = document.querySelector('#themeSwitcherToggleSwitch');
    const toggleOptions = {
      duration: 350,
      direction: (theme === 'dark') ? "reverse" : "normal"
    };

    element.setAttribute('disabled', 'disabled');


    toggler.animate(
        [
          {
            transform: "translate(0, 0)"
          },
          {
            transform: "translate(-22px, 0)"
          },
        ],
        toggleOptions
      );

      element.removeAttribute('disabled');
  };

  const showActiveTheme = (theme, focus = false) => {
    const themeSwitcher = document.querySelector('#themeSwitcherToggle');

    if (!themeSwitcher) {
      return;
    }

    const themeSwitcherText = document.querySelector('#themeSwitcherText');

    const switchValues = {
      dark: {
        text: 'Toggle theme to light',
        newValue: 'light'
      },
      light: {
        text: 'Toggle theme to dark',
        newValue: 'dark'
      }
    }

    themeSwitcherText.innerHTML = switchValues[theme].text;
    themeSwitcher.dataset.bsThemeValue = switchValues[theme].newValue;

    if (focus) {
      themeSwitcher.focus();
    }
  };

  document.addEventListener('visibilitychange', () => {
    const storedTheme = getStoredTheme();
    if (document.visibilityState === 'visible' && !isStoredTheme(storedTheme)) {
      const theme = getTimeBasedTheme();
      setTheme(theme);
      showActiveTheme(theme);
    }
  });

  window.addEventListener('DOMContentLoaded', () => {
    showActiveTheme(getPreferredTheme());

    const modeToggler = document.querySelector('#themeSwitcherToggle');
    if(!modeToggler) {
      return;
    }
    
    modeToggler.addEventListener('click', (event) => {
          const themeButton = event.currentTarget;
          const theme = themeButton.dataset.bsThemeValue;
          setStoredTheme(theme);
          setTheme(theme);
          animateButton(themeButton, theme);
          showActiveTheme(theme, true);
        });


  });

}
